import { atom } from 'jotai';

export const scrollContainerAtom = atom<HTMLDivElement | null>(null);
scrollContainerAtom.debugLabel = 'scrollContainerAtom';

export const scrollPositionAtom = atom<number>(0);
scrollPositionAtom.debugLabel = 'scrollPositionAtom';

export const pageContentAtom = atom<HTMLDivElement | null>(null);
pageContentAtom.debugLabel = 'pageContentAtom';

export const bottomStickyPortalAtom = atom<HTMLDivElement | null>(null);
bottomStickyPortalAtom.debugLabel = 'bottomStickyPortalAtom';
